<template>
  <div class="managementClass">
    <div class="managementClass-top">
      <el-button type="primary" size="small" @click="addClass" v-if="false">{{$t('managementV2.newClass')}}
      </el-button>
      <div class="search">
        <el-input v-model="searchVal" :placeholder="$t('managementV2.searchClass')"
                  @input="changinput" clearable @clear="changeClear">
        </el-input>
        <i @click="search"></i>
      </div>
    </div>
    <div class="managementClass-table">
      <el-table height="100%" border :data="managementclassList"
                header-row-class-name="customHeader">
        <el-table-column type="index" width="57" :label="$t('managementV2.number')" align="center">
          <template slot-scope="{$index}">
            {{fromateIndex($index)}}
          </template>
        </el-table-column>
        <el-table-column prop="aliasName" :label="$t('managementV2.className')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="name" @click="handleDetail(row)">
              {{row.name || '--'}}
            </span>
          </template>
        </el-table-column>

        <el-table-column v-if="false" prop="loginPhone" :label="$t('managementV2.major')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.major || '--'}}
          </template>
        </el-table-column>
        <el-table-column prop="peopleNum" :label="$t('managementV2.member')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.peopleNum || 0}}
          </template>
        </el-table-column>
        <el-table-column v-if="false" prop="createTime" :label="$t('managementV2.creationDate')" align="center"
                         show-overflow-tooltip>
          <template slot-scope="{row}">
            {{row.createTime || "--"}}
          </template>
        </el-table-column>
        <el-table-column prop="finishTaskNum" :label="$t('managementV2.numberOfJobsCompleted')"
                         align="center">
          <template slot-scope="{row}">
            {{row.finishTaskNum || 0}}
          </template>
        </el-table-column>
        <el-table-column prop="averageScore" :label="$t('managementV2.average')" align="center">
          <template slot-scope="{row}">
            {{row.averageScore || 0}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('managementV2.operation')" align="center" class-name="operate"
                         show-overflow-tooltip width="220">
          <template slot-scope="{row}">
            <el-tooltip effect="dark" :content="$t('myMessageV2.changedetail')" placement="top">
              <i class="icon-detail" @click="handleDetail(row)"></i>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" :content="$t('managementV2.addStudents')" placement="top">
              <i class="icon-add" @click="addStudents(row)"></i>
            </el-tooltip> -->
            <el-tooltip effect="dark" :content="$t('managementV2.downloadReport')" placement="top">
              <i class="icon-downloadreport" @click="downloadreport(row)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" :content="$t('managementV2.delete')" placement="top">
              <i class="icon-delete" @click="handleDelete(row.id)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <!-- <el-pagination background :total="totalRows" @current-change="handleCurrentChange"
                     @size-change="handleSizeChange" :current-page.sync="params.page"
                     :page-size="params.rows" :page-sizes="[10, 20, 30, 40]"
                     layout="prev, pager, next, sizes">
      </el-pagination> -->
    </div>
    <!-- 添加班级 -->
    <addclass-dialog :addclassVisible="addclassVisible" @handlerclassClose="handlerclassClose"
                     @handlerclassSuccess="handlerclassSuccess">
    </addclass-dialog>
    <!-- 添加学生弹窗 -->
    <addstudent-dialog :addclassVisible="addstudentVisible" @handlerclassClose="handlerstudentClose"
                       @handlerStudentSuccess="handlerStudentSuccess" :addstudentId="addstudentId">
    </addstudent-dialog>
    <!-- 删除弹窗 -->
    <delete-dialog :deleteVisible="deleteVisible" @handlerdeleteClose="handlerdeleteClose"
                   :deletTips="deletTips" :deleteId="deleteId"
                   @handlerdeleteSuccess="handlerdeleteSuccess" :deleteType="deleteType">
    </delete-dialog>
    <async-download-file :isDownloadLoading="isDownloadLoading" :asyncDownloadFun="asyncDownloadFun"
                         @handleClose="handleDownloadClose"></async-download-file>
  </div>
</template>
<script>
import addclassDialog from "../../components/addClassDialog";
import addstudentDialog from "../../components/addstudentDialog";
import deleteDialog from "../../components/deleteDialog";
import { getClassList, downloadClassMultipleHomeworkReport } from "@/services/managements";
import { getDownloadAsyncResult } from '@/services/projectDetailsApi';
import AsyncDownloadFile from '@/components/async-download-file';
export default {
  name: "managementClass",
  data() {
    return {
      searchVal: "",
      managementclassList: [],
      totalRows: 0,
      addclassVisible: false,
      deleteVisible: false,
      addstudentVisible: false,
      deletTips: this.$t("managementV2.Areyousuretodeletethisclassdata"),
      deleteId: null,
      addstudentId: null,
      isDownloadLoading: false,
      asyncDownloadFun: () => { },
      deleteType: "",
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany.code,
    }
  },
  components: { addclassDialog, deleteDialog, addstudentDialog, AsyncDownloadFile },
  created() {

  },
  mounted() {
    this.getClassList();
  },
  computed: {
  },
  methods: {
    //清除搜索内容
    changeClear() {
      this.searchVal = '';
      this.getClassList();
    },
    //搜索内容不能空格开头
    changinput() {
      this.searchVal = this.searchVal.replace(/^\s*/g, '');
    },
    fromateIndex(index) {
      if (index < 9) {
        return '0' + (index + 1)
      } else {
        return index + 1
      }
    },
    //添加班级
    addClass() {
      this.addclassVisible = true;
    },
    //关闭添加班级
    handlerclassClose() {
      this.addclassVisible = false;
    },
    //添加班级成功
    handlerclassSuccess() {
      this.addclassVisible = false;
      this.getClassList();
    },
    //获取班级列表
    async getClassList() {
      const { result, success } = await getClassList({ name: this.searchVal, companyCode: this.companyCode });
      if (success) {
        this.managementclassList = result;
      }
    },
    //搜索内容
    search() {
      this.getClassList();
    },
    //查看详情
    handleDetail(row) {
      this.$router.push({
        name: "classdetail",
        query: {
          key: this.$Base64.encode(JSON.stringify({
            id: row.id,
          }))
        }
      })
    },
    //添加学生
    addStudents(row) {
      this.addstudentVisible = true;
      this.addstudentId = row.id
    },
    //关闭添加
    handlerstudentClose(val) {
      if (val) {
        this.getClassList();
      }
      this.addstudentVisible = false;
    },
    //添加学生成功
    handlerStudentSuccess() {
      this.addstudentVisible = false;
      this.getClassList();
    },
    //下载报告
    downloadreport(row) {
      if (parseInt(row.finishTaskNum) === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('managementV2.Thenumberofjobscompletedis0Downloadingreportsisnotsupported'));
        return
      }
      this.asyncDownloadFun = () => downloadClassMultipleHomeworkReport({ companyDepartId: row.id, companyCode: this.companyCode });
      this.isDownloadLoading = true;
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => { };
      this.isDownloadLoading = false;
    },
    //删除班级
    handleDelete(id) {
      this.deleteVisible = true;
      this.deleteType = "class"
      this.deleteId = id;
    },
    //取消删除
    handlerdeleteClose() {
      this.deleteVisible = false;
    },
    //删除成功
    handlerdeleteSuccess() {
      this.deleteVisible = false;
      this.getClassList();
    },
  }
}
</script>
<style lang="less" scoped>
@import "./style.less";
</style>